import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { UnsavedStructureForNodeManagerNavigationModal } from "@src/components/organisms/modals/unsaved-structure-for-node-manager-navigation-modal/unsaved-structure-for-node-manager-navigation-modal";

export const UnsavedStructureForNodeManagerNavigation = () => {
  const showUnsavedStructureForNodeManagerNavigationModal = useSelector(
    (state: RootState) =>
      state.yourSlice.unsavedStructureForNodeManagerNavigationModal
        .showUnsavedStructureForNodeManagerNavigationModal,
  );

  return (
    <>
      {showUnsavedStructureForNodeManagerNavigationModal && (
        <UnsavedStructureForNodeManagerNavigationModal />
      )}
    </>
  );
};
